import request from '@/utils/request';
import {
  TMPURL
} from './config';

// 获取游戏列表
export function apiGetGameList(params) {
  return request.get(TMPURL + '/v1/public/game/list', params);
}